import axiosClient from '../configs/axios';


class maintenanceService {

    async getmaintenanceList(params) {
        try {
            const login_details = sessionStorage.getItem("loginUser");
            const userD = JSON.parse(login_details);
            const userInfo = userD?.result?.userInfo;
            const unit_id = userInfo?.depot_id || userInfo?.plant_id;
            const response = await axiosClient.get(
                `/maintenance/list?page=${params.page}&&size=${params.size}&&searchKey=${params.searchKey}&unit_id=${unit_id}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }



       async getmaintenanceReportList(params) {
        try {
            const login_details = sessionStorage.getItem("loginUser");
            const userD = JSON.parse(login_details);
            const userInfo = userD?.result?.userInfo;
            const unit_id = userInfo?.depot_id || userInfo?.plant_id;
            const response = await axiosClient.get(
                `/maintenance/reportowner?page=${params.page}&&size=${params.size}&&searchKey=${params.searchKey}&unit_id=${unit_id}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }


    // async getmaintenanccylinderlists(plant_id) {
    //     try {
    //         const login_details = sessionStorage.getItem("loginUser");
    //         const userD = JSON.parse(login_details);
    //         const userInfo = userD?.result?.userInfo;
    //         const unit_id = userInfo?.depot_id || userInfo?.plant_id;
    //         const response = await axiosClient.get(
    //             `/maintenance/cylinder?plant_id=${plant_id}`
    //         );
    //         return response.data;
    //     } catch (error) {
    //         throw error;
    //     }
    // }

      async getmaintenanccylinderlists(plant_id) {
        try {
            const response = await axiosClient.get(
                `/maintenance/cylinder?plant_id=${plant_id}`
            );

            return response.data;
            
        } catch (error) {
            throw error;
        }
    }


    async addmaintenance(data) {
        try {
            const response = await axiosClient.post('/maintenance/add', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }


    async editDeletemaintenance(data) {
        try {
            const response = await axiosClient.put(`/maintenance/editDelete`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default new maintenanceService(); 